import { useLoadInfinite } from '@apis/general';

export const useGetAdvertiserCategories = () => {
  return useLoadInfinite('advertiser_categories/', {
    params: { v1: true },
    ignoreAdvertiser: true,
  });
};
